"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORK_LOG_CATEGORIES = void 0;
exports.WORK_LOG_CATEGORIES = [
    'General',
    'General Meeting Prep',
    'Essay Review and Editing',
    'Parent Meeting',
    'Follow Up Email or Notes',
    'College Research Prep',
    'Activity Review Prep',
    'Course Selection Prep',
];
//# sourceMappingURL=workLogCategories.js.map